var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data":"basket-line-item-discount"}},[_c('InputField',{attrs:{"disabled":_vm.disabled,"label":_vm.t('Pages.BasketPOS.LineItemDiscount')},on:{"blur":_setup.onChange},model:{value:(_setup.discount),callback:function ($$v) {_setup.discount=$$v},expression:"discount"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }